export default __webpack_public_path__ + "static/media/ellipse.80908f6c.svg";